import { render, staticRenderFns } from "./PriceAmount.vue?vue&type=template&id=ca649324"
import script from "./PriceAmount.vue?vue&type=script&lang=js"
export * from "./PriceAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports